import {
  MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX,
  MANDATORY_CATEGORY_VISIBLE_SUFFIX,
} from '../../config'

export const cleanSettingFlag = (settingFlag: string) => {
  if (
    !!settingFlag &&
    (settingFlag.endsWith(MANDATORY_CATEGORY_VISIBLE_SUFFIX) ||
      settingFlag.endsWith(MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX))
  ) {
    settingFlag = settingFlag.substring(0, settingFlag.length - 1)
  }

  return settingFlag
}
